import { Component } from '@angular/core';

@Component({
  selector: 'app-habitation-page-container',
  templateUrl: './habitation-page-container.component.html',
  styleUrls: ['./habitation-page-container.component.scss'],
  standalone: false
})
export class HabitationPageContainerComponent {}
